import { IProduct } from "../interfase/IProduct";

export const defaultProduct: IProduct = {
  id: 0,
  producer: "",
  brend: "",
  title: "",
  type: [""],
  subtype: [""],
  packing: "",
  image: "no-image.jpg",
  barcode: "",
  price: 0,
  description: ""
}